import { render, staticRenderFns } from "./BlockView.vue?vue&type=template&id=204f4133&scoped=true&"
import script from "./BlockView.vue?vue&type=script&lang=js&"
export * from "./BlockView.vue?vue&type=script&lang=js&"
import style0 from "./BlockView.vue?vue&type=style&index=0&id=204f4133&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f4133",
  null
  
)

export default component.exports